import type { SchemaTypePresence } from './cards/StructuredDataCard';

/**
 * S2 (2026-07-22) — single source of truth for the reviewer-facing row
 * labels shared by the StructuredDataCard rail rows and the
 * StructuredDataDrawer per-type headers.
 *
 * Design ruling: row labels move to REVIEWER WORDS (the outcome the reviewer
 * cares about); the schema.org type is demoted to a small muted secondary
 * tag. The Article row is deliberately labeled "Article summary" — NEVER
 * "Search description": that label claims snippet territory and re-creates
 * the SERP-preview-card collision (SCHEMA-UX-13). `article_description` is
 * schema `Article.description`, not the meta description.
 */
export interface SchemaTypeLabel {
  /** Reviewer-facing row label (outcome words, never the raw schema type). */
  label: string;
  /** Small muted secondary tag — the demoted schema.org type name. */
  tag: string;
}

export const TYPE_LABELS: Record<SchemaTypePresence['type'], SchemaTypeLabel> = {
  Article: { label: 'Article summary', tag: 'Article · description' },
  BreadcrumbList: { label: 'Breadcrumb trail', tag: 'BreadcrumbList' },
  HowTo: { label: 'How-to steps', tag: 'HowTo' },
  FAQPage: { label: 'FAQ', tag: 'FAQPage' },
  Product: { label: 'Product details', tag: 'Product' },
};
